<div class="frame">
    <h1>Something went wrong...</h1>
    <p>Either you tried an invalid web address (URL) or the school is not set up properly.</p>
    <p></p>
    <p>You can search a list of schools that use the College Board Net Price Calculator on the Big Future website.</p>

    <a mat-flat-button color="primary" href="https://bigfuture.collegeboard.org/pay-for-college/calculate-your-cost/net-price-calculator">Big Future NPC School Selector</a>

</div>